import * as React from 'react';

export const planeIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16 22H14L9 14H3.5C2.67 14 2 13.33 2 12.5C2 11.67 2.67 11 3.5 11H9L14 3H16L13.5 11L19 11L20.5 9H22L21 12.5L22 16H20.5L19 14L13.5 14L16 22Z"
			fill="currentColor"
		/>
	</svg>
);
